"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var NotificationItem_1 = __importDefault(require("../../NotificationItem"));
var AccessRestoredIcon_1 = __importDefault(require("../../../Icons/Notifications/AccessRestoredIcon"));
var i18N = {
    en: {
        description: 'Access to your Worlds has been restored.',
        title: 'Worlds available'
    },
    es: {
        description: 'El acceso a tus Mundos ha sido restaurado.',
        title: 'Mundos disponible'
    },
    zh: {
        description: '您的 "世界 "访问权限已恢复.',
        title: '可用的世界'
    }
};
var WorldsAccessRestoredNotification = function (_a) {
    var notification = _a.notification, locale = _a.locale;
    return (react_1.default.createElement(NotificationItem_1.default, { image: { image: react_1.default.createElement(AccessRestoredIcon_1.default, { width: "48", height: "48" }) }, timestamp: notification.timestamp, isNew: !notification.read, locale: locale },
        react_1.default.createElement("p", { className: "dcl notification-item__content-title" }, i18N[locale].title),
        react_1.default.createElement("p", { className: "dcl notification-item__content-description" }, i18N[locale].description)));
};
exports.default = WorldsAccessRestoredNotification;
